import { render, staticRenderFns } from "./BaseOptions.vue?vue&type=template&id=83bdfe36&scoped=true&"
import script from "./BaseOptions.vue?vue&type=script&lang=js&"
export * from "./BaseOptions.vue?vue&type=script&lang=js&"
import style0 from "./BaseOptions.vue?vue&type=style&index=0&id=83bdfe36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83bdfe36",
  null
  
)

export default component.exports